import type { StepKey } from "@utils/interface";

/** Backend pipeline step numbers (step 2 merged into step 1; sample data is backend step 5). */
export const DEMO_LAB_BACKEND_STEPS = [1, 3, 4, 5, 7, 8, 9, 10] as const;

/** Maps UI wizard index (0–7) to backend step number used in API / stepStatus. */
export function uiIndexToBackendStep(uiIndex: number): number {
    return DEMO_LAB_BACKEND_STEPS[uiIndex] ?? 1;
}

export function uiIndexToStepKey(uiIndex: number): StepKey {
    return `step${uiIndexToBackendStep(uiIndex)}` as StepKey;
}

/** Maps a completed backend step number to the UI wizard index the user should be on. */
export function backendCompletedStepToUiIndex(backendStep: number): number {
    const index = DEMO_LAB_BACKEND_STEPS.indexOf(backendStep as (typeof DEMO_LAB_BACKEND_STEPS)[number]);
    if (index >= 0) {
        return index;
    }
    if (backendStep === 2) {
        return 0;
    }
    if (backendStep === 6) {
        // Legacy pseudo-step: treat as sample data (UI index 3).
        return 3;
    }
    return Math.max(backendStep - 3, 0);
}

/** Number of UI wizard steps completed (1–8) from a completed backend step number. */
export function backendStepsCompletedToUiCount(backendStep: number): number {
    if (backendStep <= 0) {
        return 0;
    }
    if (backendStep === 1 || backendStep === 2) {
        return 1;
    }
    if (backendStep === 3) {
        return 2;
    }
    if (backendStep === 4) {
        return 3;
    }
    if (backendStep === 5 || backendStep === 6) {
        return 4;
    }
    if (backendStep >= 10) {
        return 8;
    }
    return backendCompletedStepToUiIndex(backendStep) + 1;
}

export const DEMO_LAB_UI_STEP_COUNT = 8;
